const comments = [
  {
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20person%20with%20warm%20lighting%2C%20simple%20dark%20background%2C%20friendly%20expression%2C%20clean%20minimal%20studio%20photography&width=120&height=120&seq=avatar-user-1&orientation=squarish',
    text: '黄瓜影院的片库真的太全了！最近迷上一部冷门悬疑剧，找了很久终于在黄瓜影院找到了完整版，高清画质看得太过瘾了，而且完全不卡顿。',
    rating: 5,
    time: '2天前',
  },
  {
    name: '剧荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20person%20with%20gentle%20smile%2C%20warm%20soft%20lighting%2C%20dark%20neutral%20background%2C%20clean%20minimal%20studio%20photography%2C%20natural%20pose&width=120&height=120&seq=avatar-user-2&orientation=squarish',
    text: '智能推荐功能真的绝了，每次剧荒的时候都能给我推荐到合口味的好剧。最近通过推荐发现了好几部高分纪录片，每一部都值得反复观看。',
    rating: 5,
    time: '3天前',
  },
  {
    name: '深夜追剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20with%20warm%20artistic%20lighting%2C%20thoughtful%20expression%2C%20dark%20simple%20background%2C%20clean%20modern%20studio%20photography%2C%20relaxed%20natural%20pose&width=120&height=120&seq=avatar-user-3&orientation=squarish',
    text: '每天晚上睡前必刷黄瓜影院，更新速度真的快，热门剧集播出当天就能看到高清全集。流畅不缓冲的体验让深夜追剧变成了一种享受。',
    rating: 4,
    time: '5天前',
  },
  {
    name: '电影发烧友',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20with%20confident%20expression%2C%20warm%20cinematic%20lighting%2C%20dark%20minimal%20background%2C%20clean%20studio%20photography%2C%20professional%20friendly%20look&width=120&height=120&seq=avatar-user-4&orientation=squarish',
    text: '作为一个电影爱好者，黄瓜影院的电影大全分类真的很专业。从经典老片到最新院线，应有尽有。4K修复版的经典电影画质太震撼了！',
    rating: 5,
    time: '1周前',
  },
  {
    name: '快乐肥宅水',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20with%20cheerful%20happy%20expression%2C%20warm%20bright%20lighting%2C%20dark%20neutral%20background%2C%20clean%20studio%20photography%2C%20friendly%20casual%20smile&width=120&height=120&seq=avatar-user-5&orientation=squarish',
    text: '综艺和动漫区更新太勤快了，周末一口气刷完一整季动画，弹幕区氛围也很好。推荐给了好多人，大家都说黄瓜影院好用！',
    rating: 5,
    time: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full border border-primary-500/20 mb-3">
            用户评价
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            用户评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            来自真实用户的观影反馈与评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((cmt) => (
            <div
              key={cmt.name}
              className="bg-background-50 rounded-lg border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={cmt.avatar}
                    alt={cmt.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900">{cmt.name}</h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{cmt.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < cmt.rating ? 'ri-star-fill text-accent-400' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">{cmt.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}